import api from "../../api/v1";

export const state = () => ({
    count: 0,
    items: [],
    paginator: {
        links: [],
        first_page_url: null,
        last_page_url: null,
        prev_page_url: null,
        next_page_url: null,
        from: null,
        to: null,
        total: null,
    },
    params:{
        status: 'PickupsR',
        page: 1,
        per_page: 20,
        sort:'id',
        direction: 'desc',
        search: null
    }
})

export const actions = {
    count({commit, state}) {
        return api.basket_item.count( {status: state.params.status}).then(
            response => {
                commit('updateCount', response.count)
                return Promise.resolve(response)
            }, error => {
                return Promise.reject(error)
            }
        )
    },

    items({commit}, data) {
        return api.basket_item.items(data).then(
            response => {
                commit('updateItems', response)
                return Promise.resolve(response)
            }, error => {
                return Promise.reject(error)
            }
        )
    },

    updateStatus(context, data) {
        return this.$api.orders.update(data.id, data).then(
            response => Promise.resolve(response),
            error => Promise.reject(error)
        )
    },

    setSearch({commit},  value) {
        commit('updateSearch', value)
    },

    setSort({commit}, value){
        commit('updateSort', value)
    },

    setPerPage({commit}, value){
        commit('updatePerPage', value)
    },

    setPage({commit}, value){
        commit('updatePage', value)
    },
}

export const mutations = {
    updateItems(state, value) {
        state.items = value.data
        Object.keys(state.paginator).forEach(el => state.paginator[el] = value[el])
    },

    updateCount(state, value) {
        return state.count = value
    },

    updateSort(state, value) {
        if (value === state.params.sort) state.params.direction = state.params.direction === 'asc' ? 'desc' : 'asc';
        else state.params.sort = value;
    },

    updateSearch(state, value) {
        state.params.search = value;
    },

    updatePerPage(state, value) {
        state.params.per_page = value;
    },

    updatePage(state, value) {
        state.params.page = value;
    },
}

export const getters = {
    counter(state) {
        return state.count
    },

    items(state) {
        return state.items
    },

    paginator(state){
        return state.paginator
    },

    params(state) {
        return state.params
    }
}